import type { CSSProperties } from 'react';
import ErrorCircleFilledSvg from '../../assets/icons/error_circle_filled.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const ErrorCircleFilled: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <ErrorCircleFilledSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default ErrorCircleFilled;
